const views = [
    {
        field: 'cases',
        title: 'Cases',
        color: 'warning',
        colorHex: '#ffc107' 
    },
    {
        field: 'recovered',
        title: 'Recovered',
        color: 'success',
        colorHex: '#28a745'

    },
    {
        field: 'deaths',
        title: 'Deaths',
        color: 'danger',
        colorHex: '#dc3545'
    }
];

export default views;